import styled from "styled-components";
import { BoldableCell, ClipText, TimeDifferenceText } from "styles/text";

export const TrackStatsTable = styled.table`
  margin: 4px 0;
`;

export const HeaderTr = styled.tr`
  font-size: 10pt;

  th {
    padding: 0 5px;
    font-weight: 500;
  }
`;

export const DriverTr = styled.tr`
  td {
    padding: 5px;
    font-size: 12pt;

    @media (max-width: 700px) {
      font-size: 11pt;
    }
  }
`;

export const OrgLogoContainer = styled.div`
  width: 22px;
  height: 22px;

  @media (max-width: 700px) {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 500px) {
    width: 18px;
    height: 18px;
  }
`;

export const DriverNameContainer = styled(ClipText)`
  padding-left: 5px;
  width: 100px;
  line-height: 100%;
  vertical-align: center;
`;

export const PlayedCountTd = styled.td`
  width: 50px;
  text-align: center;
  line-height: 100%;
`;

export const BestTd = styled(BoldableCell)`
  width: 150px;
  text-align: center;
  line-height: 100%;
`;

// todo - lineHeight-100% on a default Td class and used throughout?
export const MedianTd = styled(BoldableCell)`
  width: 150px;
  text-align: center;
  line-height: 100%;
`;

export const DnfTd = styled.td`
  width: 40px;
  line-height: 100%;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const StatTimeDifferenceContainer = styled.div`
  width: 0px;
  text-align: left;
`;

export const Time = styled.div`
  width: 74px;
`;

export const BestStatTimeDifference = styled(TimeDifferenceText)`
  font-size: 9pt;
  @media (max-width: 470px) {
    display: none;
  }
`;

export const AverageStatTimeDifference = styled(TimeDifferenceText)`
  font-size: 9pt;
  @media (max-width: 500px) {
    display: none;
  }
`;
